define('views/blocks/FooterView',[
    'underscore',
    'jquery',
    'backbone',
    'app',
    'TagCommander',
    'SubView',
    'InternalLinkView',
    'InputView',
    'LazyLoad',
    'testEmail',
    'template!blocks/avisverifie-comments',
    'template!blocks/avis/avis-star',
], function (
    _,
    $,
    Backbone,
    app,
    TagCommander,
    SubView,
    InternalLinkView,
    InputView,
    LazyLoad,
    testEmail,
    AvisVerifieComments,
    AvisStarTemplate
) {
    //
    // Footer View
    //

    var view;
    var commentsPaused = false;

    return Backbone.View.extend(SubView).extend({
        el: '.footer',
        visible: true,
        events: {
            'submit .footer__newsletter__form': 'subscribeNewsletter',
            'click .apps a': 'trackClick',
            'click a.footer-link': 'trackClick',
            'click .social-links a': 'trackClick',
            'click .comments__read-more': 'commentExpand',
            'mouseenter .avisverifie__comment': 'pausePlayComments',
            'mouseleave .avisverifie__comment': 'pausePlayComments',
            'click .avisverifie-comments__content': 'toggleTwoLineParagraph',
            'click .avisverifie-comments__info-bulle': 'displayControlModal',
            'click .avisverifie-comments__avis-controle': 'displayControlModal',
        },
        initialize: function () {
            view = this;
            view.subviews = [];
            InternalLinkView.initializeLinksOfView(view);
            InputView.initializeInputsOfView(view);
            LazyLoad(view.$('.lazyload'));
            this.slideComments();
        },
        toggle: function (visible) {
            if (view.visible !== visible) {
                view.visible = visible;
                view.$el.toggle(visible == true);
            }
        },
        hide: function () {
            view.toggle(false);
        },
        show: function () {
            view.toggle(true);
        },
        trackClick: function (e) {
            var currentTarget = e.currentTarget,
                $a = $(currentTarget),
                click_level1,
                click_level3;
            if (!!$a.parents('.social-links').length) {
                click_level1 = 'social link';
                click_level3 = $a.data('social');
            } else if (!!$a.parents('.apps-links').length) {
                click_level1 = 'app link';
                click_level3 = $a.attr('class');
            } else {
                click_level1 = 'nav link';
                click_level3 = $a.text();
            }
            TagCommander.eventGA(
                currentTarget,
                'Footer ' + click_level1,
                'Clic',
                click_level3
            );
        },
        subscribeNewsletter: function (e) {
            e.preventDefault();
            var view = this,
                input = e.currentTarget[0],
                email = input.value,
                btnSubmit = view.$('.footer__newsletter__form__submit-btn');
            if (!testEmail(email)) {
                return app.alert(
                    app.t('Merci de rentrer un email valide', 'Account')
                );
            }

            btnSubmit.addClass('loading');
            function Reset() {
                btnSubmit.removeClass('loading');
                input.value = '';
                $(input).trigger('blur');
            }
            app.getCustomer()
                .registerNewsletter({ email: email })
                .done(Reset)
                .fail(Reset);
        },
        slideComments: function () {
            var view = this,
                active = 0,
                domComments = view.$('.avisverifie__comment');

            if (!domComments.length) {
                return false;
            }
            domComments.html(
                AvisVerifieComments({ app: app, THEME_URL: THEME_URL })
            );

            var comments = domComments.find('.comments__item');
            length = comments.length;

            setInterval(function () {
                if (commentsPaused) {
                    return;
                }

                view.$('.comments__item.opened').removeClass('opened');
                $(comments[active]).removeClass('active');
                active = active + 1 >= comments.length ? 0 : active + 1;
                $(comments[active]).addClass('active');
                // find ellipse and add custom class
                setTimeout(function () {
                    view.findEllispeFooter();
                }, 400);
            }, 6000);
        },
        commentExpand: function (e) {
            e.preventDefault();
            var comment = $(e.currentTarget).parents('.comments__item');
            comment.toggleClass('opened');
        },
        pausePlayComments: function () {
            commentsPaused = !commentsPaused;
        },
        toggleTwoLineParagraph: function (e) {
            var target = e.currentTarget;
            $(target).toggleClass('two-line-paragraph');
        },
        findEllispeFooter: function () {
            function isEllipsisActive(e) {
                return e.offsetHeight < e.scrollHeight;
            }

            $('.footer__avisverifie .two-line-paragraph').each(function (i, e) {
                if (isEllipsisActive(e)) {
                    $(e).addClass('ellipse-enabled');
                }
            });
        },
        displayControlModal: function () {
            app.alert({
                title: app.t('Avis soumis à un contrôle', 'avisverifie'),
                subtitle:
                    '<div class="avis-control-content">' +
                    app.c('_INFO_AVIS_VERIFIE_', '') +
                    '</div>',
            });
        },
    });
});

